//#region src/config.ts
var e = "en", t = ["en", "ar"], n = {
	en: "English",
	ar: "العربية"
}, r = (e) => typeof e == "string" && t.includes(e), i = (e) => {
	if (typeof e != "string") return null;
	let t = e.toLowerCase().split("-")[0];
	return r(t) ? t : null;
};
//#endregion
export { n as LOCALE_LABELS, e as SOURCE_LOCALE, t as SUPPORTED_LOCALES, r as isSupportedLocale, i as normalizeLocale };
